import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const FAQ = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Frequently Asked Questions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This page is reserved for Rinovo's frequently asked questions. Add your FAQ content here
          when it is ready.
        </Typography>
      </Container>
    </Box>
  );
};

export default FAQ;

